import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetAllUsersQuery } from "../../services/modules/user";

const UserDetailPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const numericId = Number(userId);

  const { data, isLoading, error } = useGetAllUsersQuery();

  const user = data?.data?.result?.find((u) => u.id === numericId);

  if (isLoading) return <p>Loading user...</p>;
  if (error) return <p className="text-red-600">Error loading user list.</p>;
  if (!user) return <p>User not found.</p>;

  return (
    <div className="p-6">
      <button
        onClick={() => navigate("/admin/utenti")}
        className="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-700"
      >
        ← Indietro
      </button>

      <h2 className="text-xl font-bold mt-5">User Details</h2>

      <table className="min-w-full text-sm border mb-4">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">ID</th>
            <th className="border px-2 py-1">Name</th>
            <th className="border px-2 py-1">Email</th>
            <th className="border px-2 py-1">Role</th>
            <th className="border px-2 py-1">Network</th>
            <th className="border px-2 py-1">Status</th>
            <th className="border px-2 py-1">Agency</th>
            <th className="border px-2 py-1">UOA</th>
            <th className="border px-2 py-1">Title</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-1">{user.id}</td>
            <td className="border px-2 py-1">{user.dislayName}</td>
            <td className="border px-2 py-1">{user.email}</td>
            <td className="border px-2 py-1">{user.role}</td>
            <td className="border px-2 py-1">{user.network?.name || "-"}</td>
            <td className="border px-2 py-1">{user.status}</td>
            <td className="border px-2 py-1">{user.agency?.name}</td>
            <td className="border px-2 py-1">{user.uoa?.name}</td>
            <td className="border px-2 py-1">{user.title}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UserDetailPage;
